import MontageList from '@/modules/Logistics/api/models/MontageList';

/**
 * MontageListRepository - VuexORM queries for montage lists
 */
export default class MontageListRepository {
    public static getAll(): MontageList[] {
        return MontageList.query()
            .withAllRecursive()
            .orderBy((list) => new Date((list as MontageList).date).getTime(), 'desc')
            .get();
    }

    public static getById(id: string): MontageList | null {
        if (!id) {
            return null;
        }
        return MontageList.query().whereId(id).withAllRecursive().first();
    }

    public static getByDate(date: string): MontageList[] {
        return MontageList.query().where('date', date).withAllRecursive().get();
    }

    public static getCount(): number {
        return MontageList.query().count();
    }

    public static exists(id: string): boolean {
        return MontageList.query().whereId(id).first() !== null;
    }

    public static deleteLocal(id: string): void {
        MontageList.delete(id);
    }

    public static clearAll(): void {
        MontageList.deleteAll();
    }
}
